import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export function callApi(requestBody: Request): Promise<Optional<void>> {
	const url: string = `${SERVICEBASEURL.BACKEND}/NutriScoreNutrientPoints`;
	return axios.put(url, requestBody).toOptionalVoid();
}

export type Request = {
	nutrientId: string; // required
	pointType: 'StandardFood' | 'Cheese' | 'Beverage' | 'AddedFat' | 'Water';
	isPositive: boolean;
	isProtein: boolean;
	points: Point[];
};

export type Point = {
	points: number;
	minValue: number | null;
};
